import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Dashboard } from './pages/Dashboard'
import { Agents } from './pages/Agents'
import { AgentBuilder } from './pages/AgentBuilder'
import { DeployAgent } from './pages/DeployAgent'
import { Teams } from './pages/Teams'
import { Monitoring } from './pages/Monitoring'
import { Settings } from './pages/Settings'
import { Login } from './pages/Login'
import { AuthCallback } from './pages/AuthCallback'
import { MentionsLegales } from './pages/MentionsLegales'
import { Contact } from './pages/Contact'
import { Privacy } from './pages/Privacy'
import { Terms } from './pages/Terms'
import { useAuthStore } from './stores/authStore'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore()
  return isAuthenticated ? (
    <>
      <div style={{ marginTop: '20px', marginLeft: '150px', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <img src="/logo.jpg" alt="AgentTeamForge Logo" style={{ width: '100px', height: '100px', objectFit: 'contain' }} />
        <h1 className="text-2xl font-bold tracking-tight text-robot-blue" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          AgentTeamForge Studio
        </h1>
      </div>
      {children}
    </>
  ) : <Navigate to="/login" replace />
}

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/login" element={<Login />} />
      <Route path="/legal/mentions" element={<MentionsLegales />} />
      <Route path="/legal/privacy" element={<Privacy />} />
      <Route path="/legal/terms" element={<Terms />} />
      <Route path="/contact" element={<Contact />} />
      
      {/* Protected routes */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/agents" element={<Agents />} />
                <Route path="/agents/new" element={<AgentBuilder />} />
                <Route path="/agents/:id/edit" element={<AgentBuilder />} />
                <Route path="/agents/deploy" element={<DeployAgent />} />
                <Route path="/teams" element={<Teams />} />
                <Route path="/monitoring" element={<Monitoring />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

export default App
